export const colDefFilterMultiSelect = "agMultiColumnFilter";
